import { AdditionForLaundryType } from 'app/constants/additionForLaundryType'

export const getAdditionForLaundryTypeName = (
  additionForLaundryType: AdditionForLaundryType,
  translate: (string) => string,
): string => {
  const text: string = AdditionForLaundryType[additionForLaundryType]
  return translate(`additionForLaundryType.${text}`)
}
